import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface H5Props extends HTMLAttributes<HTMLHeadingElement> {}

const H5 = forwardRef<HTMLHeadingElement, H5Props>(
  ({ className, children, ...props }, ref) => {
    return (
      <h5
        ref={ref}
        className={cn(
          'scroll-m-20 text-lg font-semibold tracking-tight',
          className
        )}
        {...props}
      >
        {children}
      </h5>
    );
  }
);

H5.displayName = 'H5';

export { H5 };
